export const CLINIC_STATUS = {
  NEW: "new",
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export const CLINIC_TYPE = {
  SYSTEM: "SYSTEM",
  NON_SYSTEM: "NON_SYSTEM",
};

export const CLINIC_TYPE_LABELS = {
  [CLINIC_TYPE.SYSTEM]: "SystemClinic",
  [CLINIC_TYPE.NON_SYSTEM]: "NonSystemClinic",
};

export function formatLocation(clinic) {
  const cityLine = [clinic.zipCode || null, clinic.city].filter(Boolean).join(" ");
  return [clinic.streetAddress, cityLine].filter(Boolean).join(", ");
}

export function getClinicStatus(clinic) {
  if (clinic.isPending) return CLINIC_STATUS.NEW;
  return clinic.active ? CLINIC_STATUS.ACTIVE : CLINIC_STATUS.INACTIVE;
}

export function getClinicType(clinic) {
  if (clinic.isPending) return CLINIC_TYPE.NON_SYSTEM;
  return clinic.clinicType ?? CLINIC_TYPE.SYSTEM;
}

export function getTierTitle(clinic, tiersById) {
  return tiersById.get(clinic.tierId)?.title ?? "";
}
